import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import shareImg from './shareIcon.png';

class Share extends React.PureComponent {
    render() {
        const { url, title, picUrl } = this.props;

        const sinaShare = () => {
            const brief = title.length > 120 ? `${title.slice(0, 120)}...` : title;
            const href = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
                url,
            )}&title=${encodeURIComponent(brief)}&summery=${encodeURIComponent(brief)}&pic=${encodeURIComponent(
                picUrl,
            )}`;

            window.open(href);
        };

        return (
            <div className={styles.share}>
                <img src={shareImg} onClick={sinaShare} />
            </div>
        );
    }
}

Share.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    picUrl: PropTypes.string,
};

Share.defaultProps = {};

export default errorBoundary(Share);
